/**
 * Craftia suite events → Dia calendar event shape (Timeline web).
 * Contrato: docs/contracts/craftia-events.md
 */

const KIND_COLOR = {
  trip_day: '#3B82F6',
  meal_cooked: '#F59E0B',
  pulse_session: '#8B5CF6',
  expense: '#10B981',
  street_food: '#EF4444',
  note: '#64748B',
};

/**
 * @param {Array<object>} suiteEvents — GET /api/craftia/events
 * @returns {Array<object>} calendar events compatíveis com DiaWorkspace
 */
export function suiteEventsToCalendarEvents(suiteEvents = []) {
  return suiteEvents
    .filter((e) => e && e.kind !== 'hidden')
    .map((e) => ({
      id: `suite-${e.id}`,
      title: e.title,
      start: e.occurredAt,
      allDay: false,
      resource: {
        type: `suite:${e.kind}`,
        source: e.source,
        color: KIND_COLOR[e.kind] || '#9DA3A3',
        deeplink: e.deeplink || null,
        suiteEventId: e.id,
        foreignId: e.foreignId,
      },
    }));
}

/**
 * Abre deep link do evento suite (origem). Fallback: no-op.
 * @param {object} calendarEvent
 */
export function openSuiteDeepLink(calendarEvent) {
  const href = calendarEvent?.resource?.deeplink;
  if (!href || typeof window === 'undefined') return false;
  window.location.href = href;
  return true;
}
